import React from 'react';
import './Barcode.css';
import {xpressApi, RECORD_STAT} from '../../providers/xpress_api';
import XpressDialog from '../XpressDialog/XpressDialog';
import Header from "../Common/Header/Header";
import Footer from "../Common/Footer/Footer";

export default class Barcode extends React.Component
{
    constructor(props)
    {
        super(props);

        this.questionnaire = this.props.xpressState.questionnaire;
        this.language = this.props.xpressState.language;
        this.translationConstants = this.props.xpressState.translationConstants;
        this.donorBirthDate = this.props.xpressState.dob;
        this.donorSex = this.props.xpressState.sex;
        this.sexDescription = this.props.xpressState.sexDescription;
        this.bloodCenterProperties = this.props.xpressState.bloodCenterProperties;
        this.barcodeType = this.bloodCenterProperties.barcodeType;
        this.donorPass = this.props.xpressState.donorPass;

        this.emailPackage =
        {
            encodedResponseList: this.donorPass.encodedResponseList,
            barcodeType: this.barcodeType,
            translationId: this.language,
            donorBirthDate: this.donorBirthDate,
            donorSex: this.donorSex,
            donorSexDescription: this.sexDescription, // Added the translated sex description (HD #10194)
            bloodCenterId: this.questionnaire.bloodCenterId,
            bloodCenterName: this.bloodCenterProperties.bloodCenterName,
            barcodeImageList: this.donorPass.barcodeImageList,
            showBarcodeInEmail: this.bloodCenterProperties.showBarcode,
            stage: process.env.REACT_APP_DEPLOY_ENV
        }

        this.state = {
            emailClicked: false,
            downloadClicked: false
        };
    }

    startOver = () => { window.location.href = window.origin + '/' + this.questionnaire.bloodCenterId; }

    handlePrint = async () =>
    {
        await xpressApi.get(RECORD_STAT,
        {
            params: {
                bloodCenterId: this.bloodCenterProperties.bloodCenterId,
                type: 'print'
            }

        });

        window.print();
    }

    handleDownload = async () =>
    {
        await xpressApi.get(RECORD_STAT,
        {
            params: {
                bloodCenterId: this.bloodCenterProperties.bloodCenterId,
                type: 'download'
            }
        });

        const binaryString = window.atob(this.donorPass.downloadImage);
        let bytes = new Uint8Array(binaryString.length);
        let pdfData = bytes.map((byte, i) => binaryString.charCodeAt(i));

        let file = new Blob([pdfData], { type: 'application/pdf' });
        let fileURL = URL.createObjectURL(file);

        const anchor = document.createElement('a');
        anchor.href = fileURL;
        anchor.download = 'Donor Pass.pdf';

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        this.setState({emailClicked: false, downloadClicked: true});
    }

    handleEmail = async () =>
    {
        this.setState({emailClicked: true, downloadClicked: false});
    }

    render()
    {
        let donorPassBarcodes = [];
        let donorPassHeader;
        let emailModal, downloadModal;
        let translationConstants = this.translationConstants;

        if (this.state.downloadClicked)
        {
            downloadModal = <XpressDialog contentText={this.translationConstants.fileDownloadedModalText} title={this.translationConstants.fileDownloadedModalTitle} firstButton={this.translationConstants.xpressDialogValidDateOk} open={this.state.downloadClicked}/>;
        }
        else
        {
            downloadModal = "";
        }

        if (this.state.emailClicked)
        {
            emailModal = <XpressDialog type="email" contentText={this.translationConstants.xpressEmailModalText} title={this.translationConstants.xpressDialogSendEmailTitle}
                                       firstButton={this.translationConstants.xpressDialogSendEmailSend} secondButton={this.translationConstants.xpressDialogSendEmailCancel} emailPackage={this.emailPackage}
                                       open={this.state.emailClicked} emailPlaceholder={this.translationConstants.xpressDialogSendEmailText} emailSuccessMessage={this.translationConstants.xpressDialogEmailSuccessMessage}
                                       emailInvalidMessage={this.translationConstants.xpressDialogEmailInvalidMessage} altButton={this.translationConstants.xpressDialogNavToBarcodeOk}/>;
        }
        else
        {
            emailModal = null;
        }

        let barcodeIndex = 0;
        let barcodePackage = this.donorPass;
        let dob = this.donorBirthDate;
        let sex = this.donorSex;

        let sexLabel = translationConstants.prescreenPageGender;
        let dobLabel = translationConstants.prescreenPageDOB;

        donorPassHeader = (
            <div key={barcodeIndex} style={{margin:'-13px 0px 0px 0px'}}>
                {this.language === "1" && this.questionnaire.thanksPath && <img src={this.questionnaire.thanksPath} className="mt-3 mb-3 d-print-none" style={{maxWidth: "55vw"}} alt="Thank You"/>}
                {this.language === "2" && this.questionnaire.thanksPathEs && <img src={this.questionnaire.thanksPathEs} className="mt-3 mb-3 d-print-none" style={{maxWidth: "55vw"}} alt="Gracias"/>}
                <div>
                    <h6>{sexLabel}: {this.sexDescription}</h6>
                    <h6>{dobLabel}: {dob}</h6>
                </div>
            </div>);

        barcodePackage.barcodeImageList.forEach(() => {
            let imageText = barcodePackage.encodedResponseList[barcodeIndex];
            let image = barcodePackage.barcodeImageList[barcodeIndex];

            //
            // set the sizing css based upon the type of barcode
            //

            //
            // default to code128 CSS
            //

            let barcodeImageCSS = null;
            if (this.barcodeType === 'qrcode') {
                barcodeImageCSS = {maxWidth: '200px'};
            }
            else if(this.barcodeType === 'pdf417') {
                barcodeImageCSS = {width: '100%', maxWidth: '500px', maxHeight: '150px'};
            }
            else if (this.barcodeType === 'code128') {
                barcodeImageCSS = {width: '100%'};
            }

            donorPassBarcodes.push(
                <div key={barcodeIndex} style={{marginBottom: (barcodePackage.barcodeImageList.length > 1 && barcodeIndex + 1 !== barcodePackage.barcodeImageList.length ? '20px' : '')}}>
                    <div>
                        <h6>{translationConstants.donorPageBarcode + (barcodePackage.barcodeImageList.length > 1 ? " " + (barcodeIndex + 1) : "")}:</h6>
                        <h6>{imageText}</h6>
                    </div>
                    <div>
                        <img src={"data:image/png;base64," + image} style={barcodeImageCSS} alt="Barcode"/>
                    </div>
                </div>
            );

            barcodeIndex++;
        });

        return (
            <div className="pageWrapper">
                <div className="contentWrapper">
                    <Header logoPath={this.questionnaire.logoPath} taglinePath={this.questionnaire.taglinePath}/>
                    {emailModal}
                    {downloadModal}

                    <div className="container">
                        <div className="row mb-3" style={{maxWidth:'900px', marginLeft: 'auto', marginRight: 'auto'}}>
                            <div className="col-md-12">
                                {/* Display a Thank-You message when the donor pass page is being printed */}
                                <span className="d-none d-print-block mb-4">{this.translationConstants.donorPassThankYou.replace("%BLOOD_CENTER_NAME%", this.bloodCenterProperties.bloodCenterName)}</span>
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title" style={{color: 'gray'}}>Donor Pass</h4>
                                        <hr/>
                                        <div className="text-center pt-2">
                                            {donorPassHeader}
                                            {donorPassBarcodes}
                                            <p style={{color: 'red', fontWeight: 'bold'}}>{translationConstants.donorPassExpire}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4 d-print-none">
                            <div className="col-md-12 text-center">
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-xs-4">
                                            <button type="button" className="btn btn-primary btn-lg donorPassActionBtn" onClick={this.handleDownload}>{translationConstants.donorPassDownload}</button>
                                            {/* Add vertical padding between the buttons if an XS viewport is being used, which causes them to wrap */}
                                            <div className="d-block d-sm-none" style={{paddingBottom: '10px'}}/>
                                        </div>
                                        <div className="col-xs-4">
                                            <button type="button" className="btn btn-primary btn-lg donorPassActionBtn" onClick={this.handlePrint}>{translationConstants.donorPassPrint}</button>
                                        </div>
                                        <div className="col-xs-4">
                                            <button type="button" className="btn btn-primary btn-lg donorPassActionBtn" onClick={this.handleEmail}>{translationConstants.donorPassEmail}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb-4 d-print-none">
                            <div className="col-md-12 text-center">
                                <button type="button" className="btn btn-success btn-lg donorPassActionBtn" onClick={this.startOver}>{translationConstants.donorPassStartOver}</button>
                            </div>
                        </div>
                        <div className="row d-print-none">
                            <div className="col-md-12 text-center">
                                <a href={this.bloodCenterProperties.bloodCenterUrl}>
                                    <button type="button" className="btn btn-secondary btn-sm">{translationConstants.donorPassReturnTo}<br/>{this.bloodCenterProperties.bloodCenterName}</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer text={this.translationConstants.xpressPoweredBy}/>
            </div>
        );
    }
}